var map = {
	"./article1.jpg": 692,
	"./article2.webp": 1232,
	"./article3.jpg": 8502,
	"./article4.webp": 7105,
	"./article5.webp": 377,
	"./article6.webp": 5100,
	"./article7.webp": 6639,
	"./article8.jpg": 9753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 995;